<template>
  <div class="box">
    <div>
      <OpenNav :isPlatform="isPlatform"></OpenNav>
      <!--      <Nav></Nav>-->
    </div>
    <div class="box-tip">
      <div class="close-tip">

        <img class="close-tip__icon" src="../../../assets/img/top_icon_notice.png" />
        由于整体的产品规划调整，【品牌商城】功能将于2023年9月15日下架，已经成交的订单不影响结算，尽请前往【账户中心】查看和提现。
      </div>
    </div>
    <div class="bgc">
      <div class="slide">
        <!-- 左侧菜单栏 -->
        <ul class="slide-wrapper">
          <li @click="sildeClick(0)">
            <div class="slide-item" :class="{ 'active': slideActive == 0 }">
              <img class="item-left" :src="slideActive == 0 ? imgActive.home : imgDefault.home" />
              <span class="item-right">主页</span>
            </div>
          </li>
          <li @click="sildeClick(1)">
            <div class="slide-item" :class="{ 'active': slideActive == 1 }">
              <img class="item-left" :src="slideActive == 1 ? imgActive.member : imgDefault.member" />
              <span class="item-right">会员列表</span>
            </div>
          </li>
          <li @click="sildeClick(2)">
            <div class="slide-item" :class="{ 'active': slideActive == 2 }">
              <img class="item-left" :src="slideActive == 2 ? imgActive.order : imgDefault.order" />
              <span class="item-right">订单列表</span>
            </div>
          </li>
          <li @click="sildeClick(3)">
            <div class="slide-item" :class="{ 'active': slideActive == 3 }">
              <img class="item-left" :src="slideActive == 3 ? imgActive.record : imgDefault.record" />
              <span class="item-right">流水记录</span>
            </div>
          </li>
          <li @click="sildeClick(5)">
            <div class="slide-item" :class="{ 'active': slideActive == 5 }">
              <img class="item-left" :src="slideActive == 5 ? imgActive.application : imgDefault.application" />
              <span class="item-right">应用开通</span>
            </div>
          </li>
        </ul>
      </div>
      <router-view class="main-content" v-if="isRefreshRoutter"></router-view>
    </div>
  </div>
</template>

<script>
import OpenNav from './openNav.vue'
import homeN from '@/assets/img/open/leftbar_icon_home_n.png'
import homeS from '@/assets/img/open/leftbar_icon_home_s.png'
import memberN from '@/assets/img/open/leftbar_icon_member_n.png'
import memberS from '@/assets/img/open/leftbar_icon_member_n(1).png'
import orderN from '@/assets/img/open/leftbar_icon_order_n.png'
import orderS from '@/assets/img/open/leftbar_icon_order_s.png'
import recordN from '@/assets/img/open/leftbar_icon_record_n.png'
import recordS from '@/assets/img/open/leftbar_icon_record_s.png'
import applicationN from '@/assets/img/open/leftbar_icon_application_n.png'
import applicationS from '@/assets/img/open/leftbar_icon_application_s.png'
import { getWxList } from '@/api/open.js'
import Nav from '@/components/Nav'
import loginVue from './login.vue'

export default {
  name: 'openIndex',
  components: { OpenNav, Nav },
  props: {},
  data() {
    return {
      isRefreshRoutter: false,
      imgDefault: {
        home: homeN,
        member: memberN,
        order: orderN,
        record: recordN,
        application: applicationN
      },
      imgActive: {
        home: homeS,
        member: memberS,
        order: orderS,
        record: recordS,
        application: applicationS
      },
      isPlatform: false
    }
  },
  computed: {
    slideActive() {
      return this.$store.getters.slideActive
    },
    showAppKey() {
      return this.$store.getters.showAppKey
    }
  },
  watch: {
    showAppKey(newVal, oldVal) {
      this.refreshRoutter()
    }
  },
  created() {
    const activeIndex = localStorage.getItem('sildeActive_open')
    if (activeIndex !== null) {
      this.$store.commit('nav/SET_ACTIVE_slideActive', activeIndex)
    }

    this.$store.dispatch('nav/changePersonalActiveIndex', 6)
    this.getWxList()
  },
  mounted() { },
  activated() { },
  deactivated() { },
  destroyed() { },
  methods: {
    // 转为同步任务,后续操作都要公众号信息
    async getWxList() {
      const res = await getWxList()
      console.log('WX', res);
      if (res.data.length == 0) {
        this.$router.push('/pc/open/application')
        this.isPlatform = false
      } else {
        this.isPlatform = true
        this.$store.commit('user/SET_appKey', res.data)
        this.$store.commit('user/SET_showAppKey', res.data[0])
        const lastAppName = localStorage.getItem('lastAppName')
        res.data.forEach((item, index, array) => {
          console.log('item', item.appName)
          if (item.appName == lastAppName) {
            this.$store.commit('user/SET_showAppKey', res.data[index])
          }
        })
      }
      this.isRefreshRoutter = true
    },
    sildeClick(key) {
      localStorage.setItem('sildeActive_open', key)
      this.$store.commit('nav/SET_ACTIVE_slideActive', key)
      switch (key) {
        case 0:
          this.$router.push('/pc/open/home')
          break
        case 1:
          this.$router.push('/pc/open/member')
          break
        case 2:
          this.$router.push('/pc/open/order')
          break
        case 3:
          this.$router.push('/pc/open/record')
          break
        case 5:
          this.$router.push('/pc/open/application')
          break
        default:
          break
      }
    },
    // 局部刷新页面
    refreshRoutter() {
      this.isRefreshRoutter = false
      this.$nextTick(function () {
        this.isRefreshRoutter = true
      })
    },
  }
}
</script>
<style lang='less' scoped>
.box-tip {
  width: 100%;
  padding: 12px 13.5% 0 13.5%;
  background-color: #f5f5fa;

}

.close-tip {
  background: #FF4F76;
  padding: 10px 13px;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;


  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}

.box {
  background-color: #fff;
}

.bgc {
  background-color: #f5f5fa;
  padding: 0 13.5%;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;

  .slide {
    background-color: #fdfdfd;
    margin-top: 14px;
    padding-top: 14px;
    width: 4.4rem;
    max-width: 220px;
    min-height: 888px;
    // width: 15%;
    // width: 220px;

    .slide-wrapper {
      list-style: none;

      li {
        width: 100%;
        height: 1rem;
        text-align: center;

        .slide-item {
          display: flex;
          padding: 0 0.5rem;
          height: 100%;
          cursor: pointer;
          align-items: center;
          color: #666666;
          font-size: 14px;

          .item-left {
            width: 0.4rem;
            float: left;
            margin-right: 0.5rem;
          }
        }

        .active {
          background-image: url(../../../assets/img/open/slide_active.png);
          background-size: 100% 100%;
          color: white;
        }
      }
    }
  }

  .main-content {
    background-color: white;
    flex: 1;
    margin-top: 14px;
    // padding: 0px 30px 20px 30px;
    padding: 20px 30px;
    min-width: 0;
    // max-width: 1180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/open/index.vue